import { Status } from "../../../API/LiveData/LiveDataSet";
import { DefaultGroupFormatter } from "../../../Formatters/DefaultGroupFormatter";
import { GOMAveragesGroupFormatter } from "../../../Formatters/GOMAveragesGroupFormatter";
import { WarningThreshold } from "../../../Formatters/IStationValueFormatter";
import { MainSite } from "../../../MainSite";
import { Station } from "../../../Model/Station";
import { ParameterGroupInfoSet } from "../../../ParameterGroupInfoSet";
import { PopupChartable } from "../../../PopupChartable";

interface Props {
    mainSite: MainSite,
    station: Station,
    parameterGroupId: string,
    timeRange?: "LatestValue" | "Average3h" | "Average24h",
}

export function TableValueCell(props: Props): React.JSX.Element {

    let valueFormatter;
    let valueObject;

    if (!props.timeRange || props.timeRange == "LatestValue") {
        // If no timeRange is defined, use latestData from liveDataManager
        valueFormatter = new DefaultGroupFormatter(
            ParameterGroupInfoSet[props.parameterGroupId],
            undefined,
        );
        valueObject = valueFormatter.format(
            props.mainSite.liveDataManager.latestData.Stations[props.station.Id],
            props.mainSite.selectedWarningRules
        );
    } else {
        // If a timeRange is defined, use latestData from GOMAveragesManager
        valueFormatter = new GOMAveragesGroupFormatter(
            ParameterGroupInfoSet[props.parameterGroupId],
            props.timeRange
        );
        valueObject = valueFormatter.formatGOMAverages(
            props.mainSite.GOMAveragesManager.latestData.Stations.filter(station => station.Station.Id == props.station.Id)[0],
            props.mainSite.selectedWarningRules
        );

    }

    const getCssClasses = () => {

        let cssClasses = '';

        if (valueObject.Status !== Status.Good) {
            cssClasses += ' midi_siteObsPage_expiring';
        }

        if (valueObject.WarningThreshold == WarningThreshold.Level3) {
            cssClasses += ' midi_siteObsPage_exceeded_threshold_3';
        } else if (valueObject.WarningThreshold == WarningThreshold.Level2) {
            cssClasses += ' midi_siteObsPage_exceeded_threshold_2';
        } else if (valueObject.WarningThreshold == WarningThreshold.Level1) {
            cssClasses += ' midi_siteObsPage_exceeded_threshold_1';
        }

        return cssClasses
    }

    return (
        <td
            title={`Timestamp: ${moment(moment.utc(valueObject.Timestamp)).tz(props.mainSite.selectedRegion.TimeZone).format("YYYY-MM-DD HH:mm")}. Click for parameter popup.`}
            className={getCssClasses()}
            style={{
                fontSize: ((valueObject.Status === null) || (valueObject.Value == "///")) ? "0.8em" : null,
            }}
            onClick={(e) => {
                const parameterPopup = new PopupChartable(props.mainSite, props.station, valueFormatter);
                parameterPopup.renderPopup(e);
            }}
        >
            {valueObject.Value}
        </td>
    );
}